module.exports = __webpack_public_path__ + "flags@2x.f2c77a6b7e26ff160fdb.png";


//////////////////
// WEBPACK FOOTER
// ./~/ngx-intl-tel-input/resource/img/flags@2x.png
// module id = 834
// module chunks = 2